<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useInvoiceStore } from '@/stores/invoice';
import { useConfigStore } from '@/stores/config';
const { payAtCounterCount: count } = storeToRefs(useInvoiceStore());
// Hidden unless the order setting is on; outlets created before the setting lack the key and stay off
const enabled = computed(() => !!useConfigStore().appConfig?.config?.order?.enable_pay_at_counter_badge);
</script>
<template>
  <!-- Same color as the pay_at_counter invoice status tag; parent sets the position -->
  <!-- 16px line puts Barlow's 7px digits at 5..12 in 17px box (no text-box in Electron 28); own layer snaps text and bg together -->
  <span v-if="enabled && count > 0" class="absolute min-w-[17px] h-[17px] px-1 rounded-full bg-[#FF6B35] text-white text-[10px] leading-[16px] text-center not-italic will-change-transform">{{ count > 99 ? '99+' : count }}</span>
</template>
